/* Kategori (SEO) sayfaları için hafif ortak script: burger menü + cookie banner.
   Not: Ana script.js burada bilinçli olarak kullanılmıyor, çünkü mağaza/sepet
   mantığı bu sayfalarda bulunmayan DOM elemanlarını (ör. #catRow, #shopGrid)
   varsayıyor ve hata fırlatır. */
(function(){
  var burger = document.querySelector('.burger');
  var mm = document.getElementById('mm');
  if(burger && mm){
    burger.addEventListener('click', function(){ mm.classList.toggle('open'); });
  }
})();

(function(){
  var banner = document.getElementById('cookieBanner');
  if(!banner) return;
  var consent = localStorage.getItem('cookieConsent');
  if(!consent){ banner.classList.add('show'); }
  var acceptBtn = banner.querySelector('.accept');
  var declineBtn = banner.querySelector('.decline');
  if(acceptBtn) acceptBtn.addEventListener('click', function(){
    localStorage.setItem('cookieConsent','accepted');
    banner.classList.remove('show');
  });
  if(declineBtn) declineBtn.addEventListener('click', function(){
    localStorage.setItem('cookieConsent','declined');
    banner.classList.remove('show');
  });
})();
